export default __webpack_public_path__ + "static/media/brand-visual.997d1d58.png";